import { library } from "@fortawesome/fontawesome-svg-core";
import { faGithub, faFortAwesome, faTwitter, faQq } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faBoxArchive,
    faFolder,
    faTags,
    faTag,
    faBars,
    faEnvelope,
    faFire,
    faCalendarDays,
    faEye,
    faHeartPulse,
    faAngleRight,
    faBarsStaggered,
    faPen,
    faTrashCan,
    faUser,
    faCamera,
    faComments
} from "@fortawesome/free-solid-svg-icons"

library.add(faGithub);
library.add(faFortAwesome);
library.add(faTwitter);
library.add(faQq);
library.add(faTags);
library.add(faTag);
library.add(faFire);
library.add(faCalendarDays);
library.add(faAngleRight);
library.add(faHeartPulse);
library.add(faBarsStaggered);
library.add(faTrashCan);
library.add(faPen);
library.add(faEye);
library.add(faFolder);
library.add(faBoxArchive);
library.add(faBars);
library.add(faEnvelope);
library.add(faUser);
library.add(faCamera);
library.add(faComments);


export default FontAwesomeIcon